// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"N0c75Al6","titleAndButtonRow":"DSlSwGm_","title":"igVgRbBm","buttonContainer":"TmehJTEq","styledButtonGroup":"QFnw7jT2","tooltipLabel":"g_z2VLzc"};